import { render, staticRenderFns } from "./StockTakeShare.vue?vue&type=template&id=a476a876&scoped=true&lang=pug&"
import script from "./StockTakeShare.vue?vue&type=script&lang=js&"
export * from "./StockTakeShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a476a876",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
